import React from 'react';

const ImageErrorPlaceholder = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="1" y="1" width="30" height="30" rx="3" fill="#F5F9FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.94416 5.06548C4.6002 5.43647 4.42822 5.8648 4.42822 6.35045V25.6362C4.42822 26.1504 4.62108 26.6004 5.00679 26.9862C5.39251 27.3719 5.84251 27.5647 6.35679 27.5647H25.6425C26.1282 27.5647 26.5565 27.3928 26.9275 27.0488L25.5148 25.6362H6.35679V6.47811L4.94416 5.06548ZM25.6425 21.5212V6.35045H10.4718L8.5432 4.42188H25.6425C26.1568 4.42188 26.6068 4.61473 26.9925 5.00045C27.3782 5.38616 27.5711 5.83616 27.5711 6.35045V23.4498L25.6425 21.5212ZM17.8198 17.9411L14.9068 21.7147L11.9175 17.6326L8.15679 22.5183H22.397L17.8198 17.9411Z"
        fill="#E8E8E8"
      />
      <path d="M5 4L28 27" stroke="#E8E8E8" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default ImageErrorPlaceholder;
